// Z3 Work
const header = document.querySelector('.header-wrapper');

  // Add event listener for scroll
  window.addEventListener('scroll', function() {
    // Check if the scroll position is greater than some value
    if (window.scrollY > 100) { // Change 100 to whatever scroll position you desire
      // Add 'sticky' class if scrolled down
      header.classList.add('sticky');
    } else {
      // Remove 'sticky' class if not scrolled down
      header.classList.remove('sticky');
    }
  });